import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { imageApi, fb_image } from './../../config'

class HelmetManager extends Component {
    render() {
        const { title, description, image } = this.props

        return (
            <Helmet>
                <title>
                    {`${title}${!!title ? ' @ ' : ''}KARROT Kawa i Kultura`}
                </title>
                <meta name="description" content={description} />
                <meta
                    property="og:image"
                    content={`${imageApi}${image || fb_image}`}
                />
                <meta
                    property="og:title"
                    content={title || 'KARROT Kawa i Kultura'}
                />
                <meta
                    property="og:description"
                    content={
                        description ||
                        `KARROT Kawa i Kultura
ul Częstochowska 20,
02-344 Warszawa (Ochota)`
                    }
                />
            </Helmet>
        )
    }
}

HelmetManager.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
}

HelmetManager.defaultProps = {
    title: '',
    description: '',
    image: '',
}

export default HelmetManager



// WEBPACK FOOTER //
// ./src/components/HelmetManager/HelmetManager.jsx